import React,{Component} from "react";
import $ from 'jquery';
import { withRouter } from 'react-router';
import Wrp from '../../../hoc/Wrp/Wrp';
import { connect } from 'react-redux';
import {callDELETE, callGET, callPOST} from '../../../Utils/ApiUtil';
import { validateFilesWithinSizeLimit, reportFileSizeValidationError } from '../../../Utils/FileUploadValidation';
import * as actions from '../../../store/actions';
// import BreadCrumbs from "../../../Components/UI/BreadCrumbs";
import HeaderTabs from "../../../Components/UI/HeaderTabs";
import * as ShipConstants from '../../../Global/Constants';
import {callDownloadPDF, parameterizedURLAccessToken, whiteSpaceManager} from '../../../Utils/CommonFunctions';
import {getUserInfo} from '../../../Utils/UserFunctions';
// import Icons from "../../../Components/Icons/Icons";
import ListFormatTabs from './TopNav/ListFormatTabs';
import SideBar from './SideBar/';
import MainContent from './MainContent/';
import FolderPopup from './UI/FolderPopup';
import SubFolderPopup from './UI/SubFolderPopup';
import DirectoryChoosePopup from './UI/DirectoryChoosePopup';
import ConfirmBox from '../../../hoc/ConfirmBox'
// import fileDownload from "js-file-download";


class DocumentsContainer extends Component {
    state = {
      isSplitViewOpen : true,
		  modalFolderPopup: false,
      isModalSubFolderPopup: false,
      isModalDirectoryChoosePopup: false,
      parentIdOfSubFolder:'',
      formFolderFields:{
        folder_name : {
            title : "Folder Name",                
            field : "text",
            required : false,
            placeHolder : "",
            classname : 'form-control',
            value : '',
            error: '',
            disabled:false,
            options : [] 
        },
        profile_ids:[],
        mode:'add',
        updateDirectoryId:''
      },      
      profileList:[],
      directoryLists:[],
      istoggleDirectoryAction:'',
      uploadDirectoryId: '',
      uploadDirectoryType:'Upload', //Upload, Move, Copy 
      documentToMoveOrCopyId:'',     
      ListingType:'Table',
      ListingModules: 'All', //Images, Documents, All, Directory(ListingDirectoryID send as param), Favourite
      ListingDirectoryID:'',
      ListingModulesFlag: false,
      isConfirmBoxOpen:false,
      directoryID:'',
      breadcrumbPath: [], // Array of {id, name} for breadcrumb navigation
      breadcrumbFromSidebar: false, // Flag to track if breadcrumb started from sidebar
      activeHeaderTab:'All',
      activeSidebarDirectoryId:'',
    }

    // ********** Starts: General Data *********
    componentWillMount = () => {
      this.callProfileList();
      this.assignProfiles();
      this.callDirectoryListOnly(true);
      this.fetchUserInfo();
      //this.callListingData(); // param: (image, document, allfiles, directorylist(ID))
    }
    fetchUserInfo = () => {
        callGET('users/info').then(reponse => {
          const responseData = reponse.data;
          if(responseData.code === 200) { 
          }
          }).catch(err => {
            console.log(err);
          })
        }

    componentDidUpdate(){
    // JQUERY TRIGGER FOR HOVER SETTING ICON 
    $('.btn-group.dropright').hover(function() {
        $(this).find('.dropdown-menu').stop(true, true).delay().fadeIn();
        $('.table-responsive').css( "overflow", "inherit" );
    }, function() {
        $(this).find('.dropdown-menu').stop(true, true).delay().fadeOut();
    });

    // setTimeout(function (){ 
    //     //$("#popover-content").popover("show");
    //     $("[data-toggle=popover]").popover({
    //       html: true,  
    //       content: function() {
    //               return $('#popover-content').html();
    //           }
    //     });
    // },4000);

    // $("#popover-content").popover({
    //   html: true,  
    //   content: function() {
    //           return $('#popover-content').html();
    //       }
    // });
  }

    callProfileList = () => {      
      callGET("profiles/view")
      .then(res => {      
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){
            //console.log(response.data, 'response.data')
            let activeVal = false;
            let updateProfileList = response.data.content.map((item,index)=>{
              
              return {
                profile_id: item.id,
                profile_name: item.profile_name,
                //active: activeVal
              }
            });
            this.setState({profileList:updateProfileList});
          }else{
            this.setState({profileList:[]});            
          }
        }
      }, (error) => {      
        this.props.failMessage('Something wrong on profile Listing..');
        console.log(error);
      });
    }

    assignProfiles = () => {
      let curProfileID = getUserInfo().data.profile_id;
      let updateState = { ...this.state };
      updateState.formFolderFields['profile_ids'][0] = curProfileID;
      this.setState(updateState);
    }
    // ********** Ends: General Data *********


    // ********* Starts: Listing modue main content *********

    // call method to assign ListingModules for load respective listing
    // source: 'sidebar' (from sidebar folder click) or 'list' (from list drill down) or null (other)
    assignListingModules = (ListingModules,ListingDirectoryID='', folderData=null, source=null) => {
      let updatedBreadcrumbPath = [...this.state.breadcrumbPath];
      
      // If drilling down into a directory
      let breadcrumbFromSidebar = this.state.breadcrumbFromSidebar;
      let activeSidebarDirectoryId = this.state.activeSidebarDirectoryId;

      if(ListingModules === 'Directory' && ListingDirectoryID && folderData) {
        if(source === 'sidebar' || source === 'tab_auto') {
          // From sidebar: reset breadcrumbs and start fresh from selected folder
          updatedBreadcrumbPath = [{
            id: ListingDirectoryID,
            name: folderData.name || 'Folder'
          }];
          breadcrumbFromSidebar = true;
          activeSidebarDirectoryId = ListingDirectoryID;
        } else if(source === 'list') {
          // From list: append to existing breadcrumbs (drill down)
          updatedBreadcrumbPath.push({
            id: ListingDirectoryID,
            name: folderData.name || 'Folder'
          });
          // Keep the sidebar flag if it was already set (maintains breadcrumb origin)
          // breadcrumbFromSidebar remains as is
        } else {
          // Default behavior: add to breadcrumb path
          updatedBreadcrumbPath.push({
            id: ListingDirectoryID,
            name: folderData.name || 'Folder'
          });
          if(!activeSidebarDirectoryId){
            activeSidebarDirectoryId = ListingDirectoryID;
          }
        }
      } else if(ListingModules !== 'Directory') {
        // If switching to non-directory view (All, Documents, Images, Favourite), clear breadcrumbs
        updatedBreadcrumbPath = [];
        breadcrumbFromSidebar = false;
        activeSidebarDirectoryId = '';
      }

      this.setState({
        ListingModules:ListingModules,
        ListingDirectoryID:ListingDirectoryID, 
        ListingModulesFlag:!this.state.ListingModulesFlag,
        breadcrumbPath: updatedBreadcrumbPath,
        breadcrumbFromSidebar: breadcrumbFromSidebar,
        activeSidebarDirectoryId
      })
      //this.callListingData();
    }

    handleHeaderTabClick = (tab) => {
      const { directoryLists, ListingDirectoryID, activeSidebarDirectoryId } = this.state;
      
      let targetDirectoryId = activeSidebarDirectoryId || ListingDirectoryID;
      let targetDirectory = null;
      
      if(targetDirectoryId) {
        targetDirectory = directoryLists.find(dir => dir.id === targetDirectoryId);
      }
      this.setState({
        activeHeaderTab:tab
      }, () => {
        if(targetDirectory) {
          this.assignListingModules('Directory', targetDirectory.id, targetDirectory, 'tab_auto');
        } else {
          this.assignListingModules(tab, '', null, null);
        }
      });
    }
    
    // Navigate back using breadcrumb
    navigateBreadcrumb = (index) => {
      const { breadcrumbPath, breadcrumbFromSidebar } = this.state;
      if(index === -1) {
        // Navigate to root (All files with current header filter)
        const targetTab = this.state.activeHeaderTab || 'All';
        this.assignListingModules(targetTab, '', null, null);
      } else if(index < breadcrumbPath.length) {
        // Navigate to specific breadcrumb level
        const targetBreadcrumb = breadcrumbPath[index];
        const updatedBreadcrumbPath = breadcrumbPath.slice(0, index + 1);
        // Keep the sidebar flag if breadcrumb was originally from sidebar (regardless of which level we navigate to)
        // Only reset it if we're navigating to a level that wasn't part of the original sidebar path
        const keepSidebarFlag = breadcrumbFromSidebar;
        this.setState({
          ListingModules: 'Directory',
          ListingDirectoryID: targetBreadcrumb.id,
          ListingModulesFlag: !this.state.ListingModulesFlag,
          breadcrumbPath: updatedBreadcrumbPath,
          breadcrumbFromSidebar: keepSidebarFlag
        });
      }
    } 

    // call method listing type format table or grid
    assignListingType = (ListingType) => {
      this.setState({ListingType:ListingType}) 
    }   

    // call method for delete a file
    deleteFileHandler = (fileId) => {
        // let cfrm = window.confirm("Are you sure want to delete this file ?");
        //  if(cfrm===true){
          this.props.Loader();
          callDELETE('document/file/delete?fileId='+fileId)
          .then((response) => {
            this.props.Loader();
            console.log(response);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
              this.props.succMessage(responseData.message);
              //this.callListingData();
              this.assignListingModules(this.state.ListingModules, this.state.ListingDirectoryID)
            }else {
              this.props.failMessage(responseData.message);
            }                    
          }, (error) => {
            this.props.Loader();
            this.props.failMessage('Error occured while delete file');
            //console.log(error);
          });
        //}
    }

      //call method for download file
      downloadFileHandler = (fileId, fileName="sample.pdf") => {
        let APIURL = `document/file/download?fileId=${fileId}`;
        let File = parameterizedURLAccessToken(APIURL);
        callDownloadPDF(File, fileName)
        .catch(e=>{
          this.props.failMessage(e);
        });
      }

    callMoveCopyHandler = () => {
      const uploadDirectoryId = this.state.uploadDirectoryId;
      const uploadDirectoryType = this.state.uploadDirectoryType;
      const documentToMoveOrCopyId = this.state.documentToMoveOrCopyId;
      let actionParam = "";

      if(uploadDirectoryType === 'Copy'){
        actionParam = "&copy=true";  
      }else{
        actionParam = "&copy=false";      
      }

      this.props.Loader(true);
      const header = { 'Content-Type': 'application/json' }
      const body = {}      
      callPOST("document/move?directoryId="+uploadDirectoryId+"&fileIds="+documentToMoveOrCopyId+actionParam,body,header)
      .then(response => {        
        const responseData = response.data;
        //console.log(responseData, 'responseData')
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.Loader(false);
          this.props.succMessage(responseData.message);
          this.toggleDirectoryChoosePopup('Upload','');
          this.assignListingModules(this.state.ListingModules, this.state.ListingDirectoryID);       
        }else {
          this.props.Loader(false);
          this.props.failMessage(responseData.message);
          this.toggleDirectoryChoosePopup('Upload','');
        }            
      })
      .catch(err => {
        this.props.Loader(false);        
        this.props.failMessage('Something went wrong');
        this.toggleDirectoryChoosePopup('Upload','');
      })
      
    }

    assignFavouriteHandler = (fileId,isFav) => {
      this.props.Loader(true);
      const header = { 'Content-Type': 'application/json' }
      const body = {}      
      callPOST("document/file/mark-as-favourite?fileIds="+fileId+"&markAsFavourite="+isFav,body,header)
      .then(response => {        
        const responseData = response.data;
        //console.log(responseData, 'responseData')
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.Loader(false);
          this.props.succMessage(responseData.message);
          this.assignListingModules(this.state.ListingModules, this.state.ListingDirectoryID)       
        }else {
          this.props.Loader(false);
          this.props.failMessage(responseData.message);
          this.assignListingModules(this.state.ListingModules, this.state.ListingDirectoryID)
        }            
      })
      .catch(err => {
        this.props.Loader(false);        
        this.props.failMessage('Something went wrong');
        //this.toggleDirectoryChoosePopup('Upload','');
      })   
    }
    // ********* Ends: Listing modue main content *********


    // ******* Start: Left side Bar - Add Folder Module *******    
    folderPopupHandler = () => {
      //console.log('folderPopupHandler')
      let updateState = { ...this.state };
      if(this.state.modalFolderPopup===true) {
        updateState = this.clearFormFields(updateState);
      }
      updateState.modalFolderPopup = !this.state.modalFolderPopup;
      this.setState(updateState);    
    }

    //clear fields
    clearFormFields = (updateState) => {        
        updateState.formFolderFields['folder_name'].value= '';
        updateState.formFolderFields['folder_name'].error= '';        
        updateState.formFolderFields['mode']= 'add';  
        updateState.formFolderFields['updateDirectoryId']='';      
        return updateState;
    }

    // update form value state..
    addDataHandlerFolder = (event) => {                
        const { name, value, options, selectedIndex } = event.target;        
        //console.log(name, value, options[selectedIndex].innerHTML);
        const updateState = { ...this.state };        
        // updateState.formFolderFields[name].value= value;
        if(name==='folder_name'){
          let val = whiteSpaceManager(value);
          updateState.formFolderFields[name].value= val;
         }else{
           updateState.formFolderFields[name].value= value;
          updateState.formFolderFields[name].error= '';        
        }
        updateState.formFolderFields[name].error= '';        
        console.log(updateState.formFolderFields);
        this.setState(updateState);            
    }

    // call function to add or delete profile permission for a folder
    addOrDeleteProfileHandler = (profile_id) => {
      //console.log(profile_id, 'addOrDeleteProfileHandler')
      const updateState = { ...this.state };
      if(updateState.formFolderFields['profile_ids'].indexOf(profile_id) === -1){ //check exists if add
        updateState.formFolderFields['profile_ids'].push(profile_id)
      }else{ // delete and update state.        
        let index = updateState.formFolderFields['profile_ids'].indexOf(profile_id)
        if (index !== -1) {
          updateState.formFolderFields['profile_ids'].splice(index, 1);          
        } 
      }
      this.setState(updateState);            
    }

    // call create folder API
    addFolderHandler = () => {
      console.log('addFolderHandler')
      const folder_name = this.state.formFolderFields.folder_name.value;
      const profile_ids = this.state.formFolderFields.profile_ids;
      const mode = this.state.formFolderFields.mode;
      const updateDirectoryId = this.state.formFolderFields.updateDirectoryId;
      const updateState = { ...this.state };
      let chkValid = true;
      if(folder_name===''){                            
          updateState.formFolderFields['folder_name'].error= 'Field should not empty'; 
          chkValid = false;            
      }
      let profileParam='';
      profile_ids.map((profile, index) =>{
        if(profile!==''){
            profileParam +="&profileIds="+profile;
        }
      })
      this.setState({...this.state,updateState})
      if(chkValid===false){ return false; }
      let updateParam='';
      if(mode==='update'){
        updateParam = '&id='+updateDirectoryId;
      }

      this.props.Loader(true);
      const header = { 'Content-Type': 'application/json' }
      const body = {}      
      //callPOST("document/directory/create?name="+folder_name+"&rootDirectory=false"+profileParam+updateParam,body,header)
      callPOST("document/directory/save?name="+folder_name+"&rootDirectory=false"+profileParam+updateParam,body,header)
      .then(response => {        
        const responseData = response.data;
        //console.log(responseData, 'responseData')
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.Loader(false);
          this.props.succMessage(responseData.message);
          this.folderPopupHandler(); 
          this.callDirectoryListOnly(true)       
        }else {
          this.props.Loader(false);
          this.props.failMessage(responseData.message);
          this.folderPopupHandler();
        }            
      })
      .catch(err => {
        this.props.Loader(false);        
        this.props.failMessage('Something went wrong');
        this.folderPopupHandler();
      })
    }
    // ******* Ends: Left side Bar - Add Folder Module *******


    // ******* Start: Left side Bar - Folder Listing Module *******
    callDirectoryListOnly = (isDirectoryOnly=false) => {
      console.log('isDirectoryOnly',isDirectoryOnly)
      callGET("document/search?directory_only="+isDirectoryOnly)
      .then(res => {      
        if(res.status===200){ 
          const response = res.data;
          if(response.code===200){    
            //console.log('sss',response.data.length);         
            let updateDirectoryLists = (response.data!==undefined && response.data.length!==0)?response.data[0].documents.map((item,index)=>{
              //console.log(item.documents, 'item.documents')               
              return item
            }):[];

            // Auto-select the first directory on initial load if none selected
            const shouldAutoSelect = (updateDirectoryLists && updateDirectoryLists.length > 0 && (!this.state.ListingDirectoryID || this.state.ListingDirectoryID === ''));
            
            this.setState({directoryLists:updateDirectoryLists}, () => {
              try {
                if (shouldAutoSelect) {
                  const firstDir = updateDirectoryLists[0];
                  // Use sidebar source so breadcrumbs start from the selected folder
                  this.assignListingModules('Directory', firstDir.id, firstDir, 'sidebar');
                }
              } catch (err) {
                console.error('Auto-select first directory failed', err);
              }
            });
          }else{
            this.setState({directoryLists:[]});            
          }
        }
      }, (error) => {      
        this.props.failMessage('Something wrong on profile Listing..');
        console.log(error);
      }); 
    }

    // call method to open folder action toggle
    toggleDirectoryActionHandler = (directoryID) => {
      //console.log('toggleDirectoryActionHandler')
      const updateState = { ...this.state };
      if(updateState.istoggleDirectoryAction === directoryID){
        updateState.istoggleDirectoryAction='';
      }else{       
        updateState.istoggleDirectoryAction=directoryID;
      }
      this.setState(updateState);      
    }

    toggleConfirmBox = (directoryID='') => {
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen,directoryID:directoryID});
    }

    confirmButtonClick = () => {
   
      const {directoryID} = this.state;
      this.deleteDirectoryHandler(directoryID);
      this.setState({isConfirmBoxOpen:!this.state.isConfirmBoxOpen});
    }


    // call method to delete a folder
    deleteDirectoryHandler = (directoryID) => {
      this.props.Loader(true);

      callDELETE('document/directory/delete?directoryId='+directoryID)
        .then((response) => {
          this.props.Loader(false);
          console.log(response);
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            this.props.succMessage(responseData.message);       
            // Refresh the directory list in sidebar
            this.callDirectoryListOnly(true);
            
            // Check if we need to update the main content view
            const { ListingDirectoryID, breadcrumbPath } = this.state;
            
            // If the deleted directory is currently being viewed or in breadcrumb path
            const isDeletedDirectoryInView = ListingDirectoryID === directoryID;
            const isDeletedDirectoryInBreadcrumb = breadcrumbPath.some(crumb => crumb.id === directoryID);
            
            if (isDeletedDirectoryInView || isDeletedDirectoryInBreadcrumb) {
              // Navigate back to All files view
              this.setState({
                ListingModules: 'All',
                ListingDirectoryID: '',
                ListingModulesFlag: !this.state.ListingModulesFlag,
                breadcrumbPath: [],
                breadcrumbFromSidebar: false,
                activeSidebarDirectoryId: ''
              });
            } else if (ListingDirectoryID) {
              // Refresh current directory listing
              this.assignListingModules(this.state.ListingModules, ListingDirectoryID);
            }
            
            setTimeout(() => {
              this.toggleDirectoryActionHandler(directoryID); 
            }, 100);
          }else {
            this.props.failMessage(responseData.message);
          }                    
        }, (error) => {
          this.props.Loader(false);
          this.props.failMessage('Error occured while delete directory');
          console.log(error);
        });
    }

    // call method to toggle action menu under folder
    toggleSubFolderPopup = (directoryID) => {
      console.log(directoryID);
      let updateState = { ...this.state };
      if(!this.state.isModalSubFolderPopup) {
        updateState = this.clearFormFields(updateState);
        updateState.parentIdOfSubFolder='';
      }
      updateState.isModalSubFolderPopup = !this.state.isModalSubFolderPopup;
      updateState.parentIdOfSubFolder = directoryID;
      this.setState(updateState);

      setTimeout(() => {
        this.toggleDirectoryActionHandler(directoryID); 
      }, 100);
    }

    // call method to add sub folder for a directory
    addSubFolderHandler = () => {     
      // console.log('addSubFolderHandler'); 
      const parentIdOfSubFolder = this.state.parentIdOfSubFolder;
      const folder_name = this.state.formFolderFields.folder_name.value;
      const updateState = { ...this.state };      
      let chkValid = true;
      if(folder_name===''){                            
          updateState.formFolderFields['folder_name'].error= 'Field should not empty'; 
          chkValid = false;            
      }
      if(chkValid===false){ return false; }
      
      this.props.Loader(true);
      const header = { 'Content-Type': 'application/json' }
      const body = {}      
      // callPOST("document/directory/create?name="+folder_name+"&rootDirectory=false&parentDirectoryId="+parentIdOfSubFolder,body,header)
      callPOST("document/directory/save?name="+folder_name+"&rootDirectory=false&parentDirectoryId="+parentIdOfSubFolder,body,header)
      .then(response => {        
        const responseData = response.data;
        //console.log(responseData, 'responseData')
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
          this.props.Loader(false);
          this.props.succMessage(responseData.message);
          this.toggleSubFolderPopup(); 
          this.callDirectoryListOnly(true)       
        }else {
          this.props.Loader(false);
          this.props.failMessage(responseData.message);
          this.toggleSubFolderPopup();
        }            
      })
      .catch(err => {
        this.props.Loader(false);        
        this.props.failMessage('Something went wrong');
        this.toggleSubFolderPopup();
      })
    }

    //call method for download directory module
    downloadDirectoryHandler = (directoryID) => {
      setTimeout(() => {
        this.toggleDirectoryActionHandler(directoryID); 
      }, 100);
      let APIURL = 'document/download-as-zip?directoryId='+directoryID;      
      document.location.href = parameterizedURLAccessToken(APIURL);
    }

    //call method for edit directory folder
    editFolderHandler = (directory) => {
      let uniqueIds = [];
      if(directory.profile_ids && Array.isArray(directory.profile_ids)) {
        uniqueIds = [...new Set(directory.profile_ids)];
      }
      let updateState = { ...this.state };
      updateState.formFolderFields['folder_name'].value= directory.name;
      updateState.formFolderFields['mode']='update';
      updateState.formFolderFields['updateDirectoryId']=directory.id;      
      updateState.formFolderFields['profile_ids'] = [];
      // directory.profile_ids.map((profile, item)=>{
      //   updateState.formFolderFields['profile_ids'].push(profile);
      // })
      updateState.formFolderFields['profile_ids'] = uniqueIds;
      this.setState(updateState);
      this.folderPopupHandler();
    }
    // ******* Ends: Left side Bar - Folder Listing Module *******


    // ******* Starts: Left side Bar - Directory Choose for Upload *******
    toggleDirectoryChoosePopup = (type="Upload",documentToMoveOrCopyId="") => {
      let updateState = { ...this.state };
      if(!this.state.isModalDirectoryChoosePopup) {
        //updateState = this.clearFormFields(updateState);
        updateState.uploadDirectoryId ='';
        updateState.uploadDirectoryType ='Upload';
        updateState.documentToMoveOrCopyId ='';
      }
      updateState.uploadDirectoryType = type;
      updateState.documentToMoveOrCopyId = documentToMoveOrCopyId;
      updateState.isModalDirectoryChoosePopup = !this.state.isModalDirectoryChoosePopup;      
      this.setState(updateState);  
    }

    // call method for assign directory id for upload...
    assignDirectoryForUpload = (directoryID) => {
      console.log('assignDirectoryForUpload', directoryID)
      this.setState({uploadDirectoryId:directoryID})
    }

    // call method for upload file to the directory...
    uploadFileAPICall= (files)=>{
        const sizeValidation = validateFilesWithinSizeLimit(files);
        if (!sizeValidation.valid) {
          reportFileSizeValidationError(sizeValidation.errorMsg, {
            failMessage: this.props.failMessage,
          });
          return;
        }
        const uploadDirectoryId = this.state.uploadDirectoryId;
        this.props.Loader(true); 
        Object.entries(files).map(([key, fileItem]) => {
            const formData = new FormData();            
            formData.append("upload_file", fileItem);
            const APIURL = 'document/file/upload?directoryId='+uploadDirectoryId;
            callPOST(APIURL,formData,{'Content-Type': 'multipart/form-data'})
            .then(res => {    
                if(res.status==200){ 
                  this.props.Loader(false);                       
                  const response = res.data;
                  if(response.code===200){
                    const responseData =  response.data; 
                    this.props.succMessage(response.message);
                    this.toggleDirectoryChoosePopup('Upload','');
                    this.assignListingModules(this.state.ListingModules, this.state.ListingDirectoryID)                                          
                  }else{              
                    this.toggleDirectoryChoosePopup('Upload','');         
                    this.props.failMessage((res.message!=='')?res.message:'Something went wrong..');
                  }                                                
                }else{ 
                  this.props.Loader(false); 
                  this.toggleDirectoryChoosePopup('Upload','');                                      
                  this.props.failMessage('Something went wrong..');
                }
            })
            .catch(err => {
                console.log(err);
                this.props.Loader(false); 
                this.props.failMessage('Something went wrong..');                    
            })
        })
          
    }

    toggleSplitWindow = () => {
      this.setState({isSplitViewOpen:!this.state.isSplitViewOpen});
    }
    // ******* Ends: Left side Bar - Directory Choose for Upload *******

    render(){

      const folderCRUD = {
        deleteFileHandler:this.deleteFileHandler,
        // deleteDirectoryHandler:this.toggleConfirmBox,
        downloadFileHandler:this.downloadFileHandler,
        downloadDirectoryHandler:this.downloadDirectoryHandler  
      }

      const { 
        modalFolderPopup,
        isModalSubFolderPopup,
        isModalDirectoryChoosePopup,
        formFolderFields,
        profileList,
        directoryLists,
        istoggleDirectoryAction,
        uploadDirectoryId,
        uploadDirectoryType,
        documentToMoveOrCopyId,
        ListingType,
        ListingModules,
        ListingDirectoryID,
        ListingModulesFlag,
        activeHeaderTab,
        activeSidebarDirectoryId
       } = this.state;


      let imgActive = '';
      let docActive = '';
      let allActive = '';
      let favActive = '';
      if(activeHeaderTab === 'Images'){
        imgActive = 'active';
      }else if(activeHeaderTab === 'Documents'){
        docActive = 'active'
      }else if(activeHeaderTab === 'All'){
        allActive = 'active';
      }else if(activeHeaderTab === 'Favourite'){
        favActive = 'active';
      }

      const headerTabs = [
        {
          name:"All Files",
          attributes:{
            "aria-selected":true,
            className:"nav-link "+allActive
          },
          //href:"#",
          clickHandler:this.handleHeaderTabClick.bind(this,'All'),
        },
        {
          name:"Documents",
          attributes:{
            "aria-selected":true,
            className:"nav-link "+docActive
          },
          //href:"#",
          clickHandler:this.handleHeaderTabClick.bind(this,'Documents'),          
        },
        {
          name:"Images",
          attributes:{
            "aria-selected":true,
            className:"nav-link "+imgActive
          },
          clickHandler:this.handleHeaderTabClick.bind(this,'Images') 
        },
        {
          name:"Favourite",
          attributes:{
            "aria-selected":true,
            className:"nav-link "+favActive
          },
          clickHandler:this.handleHeaderTabClick.bind(this,'Favourite') 
        }
      ]
      // console.log(this.state.formFolderFields)
    	return(
    		<Wrp>
    			<div className="page-header">
            <HeaderTabs 
              attributes={{
                className:"nav nav-pills navcrm-primary nav-pills-no-bd",
              }} 
              headerTabsList={headerTabs} 
            />
            <ListFormatTabs assignListingType={this.assignListingType} ListingType={ListingType} />            
  				</div>

          <div className="viewport">
            <div className="view view-xl" id="wrapper">
               
                <div className="portTwoSection" >
                    <SideBar 
                    toggleFolderPopup={this.folderPopupHandler}
                    directoryLists={JSON.stringify(directoryLists)}                    
                    istoggleDirectoryAction={istoggleDirectoryAction}
                    toggleDirectoryActionHandler={this.toggleDirectoryActionHandler}
                    toggleSubFolderPopup={this.toggleSubFolderPopup}
                    editFolderHandler={this.editFolderHandler}
                    toggleDirectoryChoosePopup={this.toggleDirectoryChoosePopup}
                    assignListingModules={this.assignListingModules}
                    ListingModules={ListingModules}
                    ListingDirectoryID={ListingDirectoryID}
                    activeSidebarDirectoryId={activeSidebarDirectoryId}
                    toggleSplitWindow={this.toggleSplitWindow}
                    isSplitViewOpen={this.state.isSplitViewOpen}
                    {...folderCRUD}
                    deleteDirectoryHandler={this.toggleConfirmBox}
                    />
                    <MainContent
                    assignListingModules={this.assignListingModules}                    
                    toggleSubFolderPopup={this.toggleSubFolderPopup}
                    toggleDirectoryChoosePopup={this.toggleDirectoryChoosePopup}
                    assignFavouriteHandler={this.assignFavouriteHandler}
                    {...folderCRUD}
                    ListingType={ListingType}
                    ListingModules={ListingModules}
                    ListingDirectoryID={ListingDirectoryID}
                    ListingModulesFlag={ListingModulesFlag}
                    breadcrumbPath={this.state.breadcrumbPath}
                    navigateBreadcrumb={this.navigateBreadcrumb}
                    breadcrumbFromSidebar={this.state.breadcrumbFromSidebar}
                    activeHeaderTab={activeHeaderTab}
                    {...this.props}     
                    deleteDirectoryHandler={this.deleteDirectoryHandler}            
                    />
                </div>  
               
            </div>
          </div>

          <FolderPopup 
          modalFolderPopup={modalFolderPopup} 
          toggleFolderPopup={this.folderPopupHandler} 
          addFolderHandler={this.addFolderHandler}
          formFolderFields={JSON.stringify(formFolderFields)}
          addDataHandlerFolder={this.addDataHandlerFolder}
          profileList={JSON.stringify(profileList)}
          addOrDeleteProfileHandler={this.addOrDeleteProfileHandler}
          />

          <SubFolderPopup 
          isModalSubFolderPopup={isModalSubFolderPopup}
          formFolderFields={JSON.stringify(formFolderFields)}
          toggleSubFolderPopup={this.toggleSubFolderPopup} 
          addSubFolderHandler={this.addSubFolderHandler}
          addDataHandlerFolder={this.addDataHandlerFolder}
          />

          <DirectoryChoosePopup 
          isModalDirectoryChoosePopup={isModalDirectoryChoosePopup}
          toggleDirectoryChoosePopup={this.toggleDirectoryChoosePopup}
          directoryLists={JSON.stringify(directoryLists)}
          assignDirectoryForUpload={this.assignDirectoryForUpload}
          uploadDirectoryId={uploadDirectoryId}
          uploadDirectoryType={uploadDirectoryType}
          documentToMoveOrCopyId={documentToMoveOrCopyId}
          uploadFileAPICall={this.uploadFileAPICall}
          callMoveCopyHandler={this.callMoveCopyHandler}
          />

         <ConfirmBox
            isConfirmBoxOpen={this.state.isConfirmBoxOpen}
            toggleConfirmBox={this.toggleConfirmBox}
            confirmButtonClick={this.confirmButtonClick}
            //content={this.state.content}
          />  
    		</Wrp>
    	)
    }
}

const mapDispatchToProps = dispatch => {
    return {
      Loader : () => dispatch(actions.loader()),
      succMessage : (msg) => dispatch(actions.succMessage(msg)),
      failMessage : (msg) => dispatch(actions.failMessage(msg))    
    };
  }
export default
connect(
    null, 
    mapDispatchToProps
)(withRouter(DocumentsContainer));